import { Injectable } from "@angular/core";
import { Helper } from "@helpers/functions";

@Injectable({
	providedIn: "root"
})
export class DarkModeService {
	public get darkModeEnabled(): boolean {
		return Helper.getCookie("dark_mode", true) === "true";
	}

	public toggleDarkMode(theme?: "dark" | "light"): void {
		const newValue = theme ? theme === "dark" : !this.darkModeEnabled;
		Helper.setCookie("dark_mode", newValue.toString(), true);
		this.setColorTheme();
	}

	public setColorTheme(): void {
		this.darkModeEnabled ? this.setDarkTheme() : this.setLightTheme();
	}

	private setDarkTheme(): void {
		document.body.classList.add("dark", "of-tnum");
	}

	private setLightTheme(): void {
		document.body.classList.remove("dark");
		document.body.classList.add("of-tnum");
	}
}
